import {
  SET_PAGINATION,
  SET_CURRENCY,
  SET_ALLOWED_CURRENCIES,
  TRANSACTIONHISTORY_REQUEST,
  TRANSACTIONHISTORY_SUCCESS,
  TRANSACTIONHISTORY_FAILURE,
  ALLOWED_CURRENCIES_REQUEST,
  ALLOWED_CURRENCIES_SUCCESS,
  ALLOWED_CURRENCIES_FAILURE,
  CLEANUP,
} from "./transactionHistoryType";

import { getTransactionHistory, getTransactionCurrencies } from "api/api";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setPagination = (pagination) => {
  return {
    type: SET_PAGINATION,
    pagination: pagination,
  };
};

export const setCurrency = (currency) => {
  return {
    type: SET_CURRENCY,
    currency: currency,
  };
};

export const setAllowedCurrencies = (allowedCurrencies) => {
  return {
    type: SET_ALLOWED_CURRENCIES,
    allowedCurrencies: allowedCurrencies,
  };
};

const transactionHistoryRequest = () => {
  return {
    type: TRANSACTIONHISTORY_REQUEST,
  };
};

const transactionHistorySuccess = (payload) => {
  return {
    type: TRANSACTIONHISTORY_SUCCESS,
    payload: payload,
  };
};

const transactionHistoryFailure = (error) => {
  return {
    type: TRANSACTIONHISTORY_FAILURE,
    payload: error,
  };
};

export const callGetTransactionHistory = (currency, pageNumber) => {
  return async (dispatch) => {
    dispatch(transactionHistoryRequest());
    try {
      var response = await getTransactionHistory(currency, pageNumber-1);

      // return data
      dispatch(transactionHistorySuccess(response));
    } catch (error) {
      dispatch(transactionHistoryFailure(error.message));
    }
  };
};

const allowedCurrenciesRequest = () => {
  return {
    type: ALLOWED_CURRENCIES_REQUEST,
  };
};

const allowedCurrenciesSuccess = (payload) => {
  return {
    type: ALLOWED_CURRENCIES_SUCCESS,
    payload: payload,
  };
};

const allowedCurrenciesFailure = (error) => {
  return {
    type: ALLOWED_CURRENCIES_FAILURE,
    payload: error,
  };
};

export const callGetTransactionCurrencies = () => {
  return async (dispatch) => {
    dispatch(allowedCurrenciesRequest());
    try {
      var response = await getTransactionCurrencies();
      // support ALL currencies
      var currencies = ['ALL'];
      // return data
      dispatch(allowedCurrenciesSuccess(currencies.concat(response)));
    } catch (error) {
      dispatch(allowedCurrenciesFailure(error.message));
    }
  };
};
